export enum FailedEmailStatus {
  FAILED = 'FAILED',
  RETRYING = 'RETRYING',
  DISMISSED = 'DISMISSED',
  RESOLVED = 'RESOLVED',
}

export interface RawFailedEmailRow {
  id: number;
  status: FailedEmailStatus;
  reasonCode: string;
  createdAt: string;
  updatedAt: string;
  dismissedAt?: string;
  resolvedAt?: string;
  retryingSince?: string;
  subject?: string;
  invoiceNumber?: string;
  recipient?: string;
  recipientCc?: string;
  recipientBcc?: string;
  allRecipients?: string;
}

export interface FailedEmailRow {
  id: number;
  status: FailedEmailStatus;
  createdAt: string;
  reasonDisplay: string;
  recommendedAction: string;
  subject: string;
  invoiceNumber: string;
  recipient: string;
  recipientCc: string;
  recipientBcc: string;
  allRecipients: string;
  reasonCode: string;
  dismissedAt?: string;
  resolvedAt?: string;
  retryingSince?: string;
}
